<template>
<v-card flat>
  <v-card-text >
    <div ><strong>Monday:</strong> {{format(hours["mon"])}}</div>
    <div ><strong>Tuesday:</strong> {{format(hours["tues"])}}</div>
    <div ><strong>Wednesday:</strong> {{format(hours["wed"])}}</div>
    <div ><strong>Thursday:</strong> {{format(hours["thurs"])}}</div>
    <div ><strong>Friday:</strong> {{format(hours["fri"])}}</div>
    <div ><strong>Saturday:</strong> {{format(hours["sat"])}}</div>
    <div ><strong>Sunday:</strong> {{format(hours["sun"])}}</div>
  </v-card-text>
  <v-card-actions >
    <v-spacer />
    <v-btn
      @click='edit=true'
      class='mt-3' color='primary' >
      Edit
    </v-btn>
  </v-card-actions>

  <v-dialog v-model='edit' width=400 scrollable >
    <operating-hours v-if='edit' :autosave='edit' v-model="hours" @close='edit=false' />
  </v-dialog>
</v-card>
</template>

<script>
import OperatingHours from './OperatingHours'
// const OperationHourFields = ['mon', 'tues', 'wed', 'thurs', 'fri', 'sat', 'sun']

export default {
  name: 'OperatingHoursView',
  components: { OperatingHours },
  props: {
    hours: { type: Object, default: () => { return {} } }
  },
  data () {
    return {
      edit: false
    }
  },
  methods: {
    format (hrs) {
      if (!hrs || hrs === '') { return 'Not available for bookings' }
      return hrs.replace(/\|/g, ', ')
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// OperatingHoursView.vue?3d94ea61